/**
 * @file: AnyMedia.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { MediaObject } from '@euler/model/MediaObject';
import { MediaSourceType } from '@euler/model/report';

export type AnyMedia = {
  id: number;
  cid: string;
  type: string;
  url: string;
  coverUrl?: string;
  title?: string;
  subTitle?: string;
  dateRef?: string | Date;
  createdAt: string | Date;
  annotationMetadata?: string;
  remark?: string;
  description?: string;
};

export interface MediaWithSource {
  _id: string;
  orgId: number;
  storeId: number;
  licensePlateNo: string;
  vin: string;
  mileage: number;
  source: MediaSourceType;
  type: string;
  url: string;
  coverUrl?: string;
  urlWithAnnotation?: string;
  title?: string;
  subTitle?: string;
  description?: string;
  dateRef: Date;
  timestamp: Date;
  annotationMetadata?: string;
}

export const mediaWithSourceToMediaObject = (
  media: MediaWithSource,
  options?: {
    preferOriginalUrl?: boolean;
  },
): MediaObject => {
  return {
    id: media._id,
    type: /image/i.test(media.type) ? 'image' : 'video',
    url: media.url,
    coverUrl:
      /image/i.test(media.type) && options?.preferOriginalUrl
        ? undefined
        : media.coverUrl,
    title: media.title,
    subTitle: media.subTitle,
    description: media.description,
  };
};
